import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { getDefaultTableColumns } from 'src/app/common/ag-grid-table/default-table-columns';
import { TextCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { LineItemCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/line-item/line-item.component';
import { DropdownEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/dropdown/dropdown.component';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { OptionsParams, UtilitiesService } from 'src/app/common/services/utilities.service';

@Component({
  selector: 'app-mystery-box-content-table-ag-grid',
  templateUrl: './mystery-box-content-table-ag-grid.component.html',
  styleUrls: ['./mystery-box-content-table-ag-grid.component.sass']
})
export class MysteryBoxContentTableAgGridComponent implements OnInit {

  public entity: string = 'mystery-box-content';
  public columnDefs: ColDef[] = [];
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  public autopopulateSelect: string = '';
  public buildParams: any = {};
  public tableParams: any = {};

  private options: any = {};

  constructor(
    private utilitiesService: UtilitiesService,
    private agGridToolsService: AgGridToolsService,
  ) {
    this.autopopulateSelect = '';
  }

  async ngOnInit(): Promise<void> {
    await this.setOptions();

    const defaultColumns = getDefaultTableColumns(this.entity, this.agGridToolsService);

    this.columnDefs = [
      ...defaultColumns,
      {
        headerName: 'Name',
        field: 'name',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        cellEditor: 'agTextCellEditor',
        type: 'editableColumn',
      },
      {
        headerName: 'Description',
        field: 'description',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        cellEditor: 'agTextCellEditor',
        type: 'editableColumn',
      },
      {
        headerName: 'Entry Type',
        field: 'entryType',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        cellEditor: DropdownEditorComponent,
        type: 'editableColumn',
        cellEditorParams: {
          optionValue: 'value',
          optionLabel: 'label',
          options: [
            { label: 'Collection', value: 1 },
            { label: 'Item', value: 2 }
          ]
        }
      },
      {
        headerName: 'Weight',
        field: 'weight',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        type: 'editableColumn',
        cellEditor: "agNumberCellEditor",
      },
      {
        headerName: 'Line Item',
        field: 'lineItem',
        cellRenderer: LineItemCellRendererComponent,
        sortable: false,
        resizable: true,
        autoHeight: true,
        width: 300,
      },
      {
        headerName: 'Item Collection Ref',
        field: 'itemCollectionRef',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          filterKey: 'itemCollectionRef',
          isAggregate: true,
          values: this.options.itemCollectionRef,
          populate: true,
          select: 'id name _id'
        },
        width: 300,
        autoHeight: true,
        cellEditor: DropdownEditorComponent,
        type: 'editableColumn',
        cellEditorPopup: false,
        cellEditorParams: {
          optionValue: '_id',
          optionLabel: 'name',
          objectValue: true
        },
      },
      {
        headerName: 'Coin Weight',
        field: 'coinWeight',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          filterKey: 'coinWeight',
          isAggregate: true,
          values: this.options.coinWeight,
          populate: true,
          select: 'id name _id displayName'
        },
        width: 200,
        autoHeight: true,
        cellEditor: DropdownEditorComponent,
        type: 'editableColumn',
        cellEditorPopup: false,
        cellEditorParams: {
          optionValue: '_id',
          optionLabel: 'name',
          objectValue: true
        },
      },
      {
        headerName: 'Diamond Weight',
        field: 'diamondWeight',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          filterKey: 'diamondWeight',
          isAggregate: true,
          values: this.options.diamondWeight,
          populate: true,
          select: 'id name _id displayName'
        },
        width: 200,
        autoHeight: true,
        cellEditor: DropdownEditorComponent,
        type: 'editableColumn',
        cellEditorPopup: false,
        cellEditorParams: {
          optionValue: '_id',
          optionLabel: 'name',
          objectValue: true
        },
      },
    ];

    this.bulkUpdateColDefs = [
      {
        name: 'Name', id: 'name', type: 'text'
      },
      {
        name: 'Entry Type', id: 'entryType', type: 'dropdown',
        options: [
          { label: 'Collection', value: 1 },
          { label: 'Item', value: 2 }
        ]
      },
      {
        name: 'Weight', id: 'weight', type: 'number'
      },
      {
        name: 'Start', id: 'start', type: 'date'
      },
      {
        name: 'End', id: 'end', type: 'date'
      },
      {
        name: 'Enabled', id: 'enabled', type: 'boolean', onLabel: 'Enabled', offLabel: 'Disabled'
      },
      {
        name: 'Environment(s)', id: 'env', type: 'multiselect', isFlatList: true
      },
    ];

    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);
  }

  async setOptions() {
    const entities = [
      { ref: 'itemCollectionRef', entity: 'collections', select: 'id _id name', query: {} },
      { ref: 'coinWeight', entity: 'nurture-rarity', select: 'id _id name displayName', query: {} },
      { ref: 'diamondWeight', entity: 'nurture-rarity', select: 'id _id name displayName', query: {} },
    ];

    for (const { ref, entity, select, query } of entities) {
      const params = new OptionsParams({
        entity, select, query
      });
      await this.utilitiesService.getOptions(this.options, ref, params);
    }
  }
}

